























// Import vendors ----------------------------------------------------------------------------------
import { computed, defineComponent } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartWalkingWidgetSymmetry from '@/components/charts/walking/widgets/ChartWalkingWidgetSymmetry.vue';
import ChartWalkingWidgetSpeed from '@/components/charts/walking/widgets/ChartWalkingWidgetSpeed.vue';
import ChartWalkingWidgetCadence from '@/components/charts/walking/widgets/ChartWalkingWidgetCadence.vue';
import ChartWalkingWidgetScoringSQI from '@/components/charts/walking/widgets/ChartWalkingWidgetScoringSQI.vue';
import ChartWalkingWidgetScoringGVI from '@/components/charts/walking/widgets/ChartWalkingWidgetScoringGVI.vue';
// import ChartWalkingWidgetScoringGVI from '@/components/charts/walking/widgets/ChartWalkingWidgetScoringGVI.vue';

export default defineComponent({
  name: 'ChartWalkingContainerGroupBanner',
  components: {
    ChartWalkingWidgetSymmetry,
    ChartWalkingWidgetSpeed,
    ChartWalkingWidgetCadence,
    ChartWalkingWidgetScoringSQI,
    ChartWalkingWidgetScoringGVI
  },
  props: {
    aggregates: {
      type: Object,
      required: true
    },
    norms: {
      type: Object,
      required: true
    },
    displayMetrics: {
      type: Object,
      required: true
    },
    recommendations: {
      type: Object,
      required: false
    },
    degraded: {
      type: Boolean
    },
    simple: {
      type: Boolean
    },
    analysis: {
      type: Object,
      required: true
    }
  },
  setup(properties) {
    // It is show in bar
    const showNonSimpleWidget = computed(() => {
      const subscriptionId = properties.analysis?.subscriptionId;
      return (
        subscriptionId === 'injury_rehabilitation_movement_screening' ||
        subscriptionId === 'sports_medicine_return_to_play'
      );
    });

    // It is show in export
    const showSQIWidget = computed(() => {
      const subscriptionId = properties.analysis?.subscriptionId;
      return (
        subscriptionId === 'injury_rehabilitation_movement_screening' ||
        subscriptionId === 'sports_medicine_return_to_play' ||
        subscriptionId === 'neurological_elderly_mobility_monitoring'
      );
    });

    // It is show in export
    const showGVIWidget = computed(() => {
      const subscriptionId = properties.analysis?.subscriptionId;
      return subscriptionId === 'neurological_elderly_mobility_monitoring';
    });

    // const showScoringWidget = useLocalStorage('showScoringWidget', null);
    // const haveScoring = computed(() => properties.displayMetrics.value.aggregates.walking_SQI);
    return { showNonSimpleWidget, showSQIWidget, showGVIWidget };
  }
});
